import { NgModule } from '@angular/core';
import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[integeronly]',
    host: {
        '(input)': 'onInputChange()',
    },
})
export class IntegerOnlyDirective {
    constructor(public model: NgControl) {}

    onInputChange() {
        //var newValue = this.model.value.toUpperCase();
        if (this.model.value) {
            let newValue = this.model.value.replace(/[^0-9]/g, '');
            this.model.valueAccessor.writeValue(newValue);
            this.model.viewToModelUpdate(newValue);
        }
    }
}

@NgModule({
    imports: [],

    declarations: [IntegerOnlyDirective],
    exports: [IntegerOnlyDirective],
})
export class IntegerOnlyDirectiveModule {}
